/*------------------------------------*\
    SITE NAV
\*------------------------------------*/
class SiteNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const toggle = document.querySelector('.js-menu-toggle');
        const app = document.querySelector('.js-app');
        const body = document.querySelector('body');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();
            toggle.classList.toggle('is-active');
            app.classList.toggle('is-active');
            body.classList.toggle('is-no-scroll');
        });
    }
}

export default SiteNav;
